export class ShipmentDelete {

    public rowVersion : string = '';

    constructor(rowVersion: string) {
        this.rowVersion = rowVersion;
    }

}
